'use client';
import { resolveImageAlt } from '@eliadmin/core/src/utils/image-alt-utils';


import Image from '@eliadmin/core/src/components/image/image-wrapped';
import type { TImage } from '@eliadmin/core/src/types/image';
import { cn } from '@eliadmin/core/src/utils/style-utils';
import { useDisclosure } from '@eliadmin/core/src/hooks/use-disclosure';
import { useState } from 'react';
import { LightboxComponent } from '@eliadmin/core/src/components/lightbox/lightbox-component';
import { Button } from '@eliadmin/core/src/components/ui/button';
import { useTranslations } from '@eliadmin/core/src/hooks/use-translations';

export const ProjectGallery = ({ gallery }: { gallery: TImage[] }) => {
  const { t } = useTranslations();
  const { isOpen, setIsOpen } = useDisclosure(false);
  const [imagesSorted, setImagesSorted] = useState([]);
  const [visibleCount, setVisibleCount] = useState(8);

  const handleOpenGallery = (images: any, index: number) => () => {
    if (Array.isArray(images) && index >= 0 && index < images.length) {
      const newImages = [...images.slice(index), ...images.slice(0, index)];
      setImagesSorted(newImages);
      setIsOpen(true);
    } else if (images && !Array.isArray(images)) {
      setImagesSorted([images]);
      setIsOpen(true);
    }
  };

  const getColumnSpan = (index: number) => {
    if (index === 0) return 'col-span-12';
    const patternIndex = (index - 1) % 5;
    return patternIndex === 0 || patternIndex === 1 ? 'sm:col-span-6' : 'sm:col-span-4';
  };

  const showMoreImages = () => {
    setVisibleCount(prevCount => prevCount + 8);
  };

  return (
    <>
      <LightboxComponent isOpen={isOpen} setIsOpen={setIsOpen} images={imagesSorted} />
      <section className={cn('custom-section', 'mt-16')}>
        <div className={cn('custom-container', 'grid grid-cols-12 gap-2')}>
          {gallery.slice(0, visibleCount).map((image, index) => (
            <div
              key={index}
              onClick={handleOpenGallery(gallery, index)}
              className={cn(
                'relative col-span-12 aspect-video w-full cursor-pointer',
                getColumnSpan(index),
              )}
            >
              <Image
                src={image.url}
                alt={resolveImageAlt(image, undefined)}
                fill
                style={{ objectFit: 'cover', objectPosition: 'center' }}
                sizes="(min-width: 640px) 80vw, 100vw"
                loading='eager'
              />
            </div>
          ))}
        </div>
        {visibleCount < gallery.length && (
          <div className="text-center mt-4">
            <Button
              onClick={showMoreImages}
            >
              {t('text3378')}
            </Button>
          </div>
        )}
      </section>
    </>
  );
};
